<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter">Acknowledgements</h1>
<p class="nonindent1">I remain indebted to my agents, Joshua Bilmes and Eddie Schneider, for their long- standing support, ever-inspired suggestions and assistance, as well as to Krystyna Lopez and Lisa Rodgers for their work on foreign sales and print editions. Many thanks to Betsy Mitchell for her excellent editing. Thanks also to Robert Chase, Kelly Dwyer, Carolyn Ives Gilman, J.G. (Huck) Huckenpohler, Simcha Kuritzky, Michael LaViolette, Aly Parsons, Bud Sparhawk and Constance A. Warner for their suggestions, comments and recommendations.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?62942d57